import React from "react";


import Header from "../components/Header.jsx";
import Hero from "../components/Hero.jsx";
import HowItWorks from "../components/HowItWorks.jsx";
import About from "../components/About.jsx";
import PhysioCarousel from "../components/PhysioCarousel.jsx";
import FAQ from "../components/FAQ.jsx";
import TrustSection from "../components/TrustSection.jsx";
import Footer from "../components/Footer.jsx";
import { useCurrentLang } from "../hooks/useCurrentLang.js";

import "../styles/globals.css";
import "../styles/layout.css";


const HomePage: React.FC = () => {
  const currentLang = useCurrentLang();

  return (
    <div className="main-layout">
      <Header lang={currentLang} />
      <main>
        <Hero lang={currentLang} />
        <HowItWorks lang={currentLang} />
        <About lang={currentLang} />
        {/*<PhysioCarousel lang={currentLang} />*/}
        <FAQ lang={currentLang} />
        <TrustSection lang={currentLang} />
      </main>
      <Footer lang={currentLang} />
    </div>
  );
};

export default HomePage;
